var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpcomingCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2V4",
    stroke: "#002A69",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2V4",
    stroke: "#002A69",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11C14.1046 11 15 11.8954 15 13C15 14.1046 14.1046 15 13 15C11.8954 15 11 14.1046 11 13C11 11.8954 11.8954 11 13 11ZM13.8779 12.3604C13.8006 12.2895 13.6812 12.2947 13.6104 12.3721L12.8223 13.2314L12.3789 12.8223C12.3018 12.7511 12.1815 12.7559 12.1104 12.833C12.0394 12.9101 12.0441 13.0305 12.1211 13.1016L12.7041 13.6396C12.7411 13.6738 12.7905 13.6914 12.8408 13.6895C12.8913 13.6873 12.9395 13.6652 12.9736 13.6279L13.8896 12.6279C13.9605 12.5506 13.9553 12.4312 13.8779 12.3604Z",
    fill: "#002A69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C13.1046 3 14 3.89543 14 5V10.1738C13.6869 10.0631 13.351 10 13 10C11.3431 10 10 11.3431 10 13C10 13.351 10.0631 13.6869 10.1738 14H4C2.89543 14 2 13.1046 2 12V5C2 3.89543 2.89543 3 4 3H12ZM4.40039 8.5C4.17948 8.5 4 8.67948 4 8.90039V10.0996C4 10.3205 4.17948 10.5 4.40039 10.5H5.59961C5.82052 10.5 6 10.3205 6 10.0996V8.90039C6 8.67948 5.82052 8.5 5.59961 8.5H4.40039ZM7.40039 8.5C7.17948 8.5 7 8.67948 7 8.90039V10.0996C7 10.3205 7.17948 10.5 7.40039 10.5H8.59961C8.82052 10.5 9 10.3205 9 10.0996V8.90039C9 8.67948 8.82052 8.5 8.59961 8.5H7.40039ZM4.40039 5.5C4.17948 5.5 4 5.67948 4 5.90039V7.09961C4 7.32052 4.17948 7.5 4.40039 7.5H5.59961C5.82052 7.5 6 7.32052 6 7.09961V5.90039C6 5.67948 5.82052 5.5 5.59961 5.5H4.40039ZM7.40039 5.5C7.17948 5.5 7 5.67948 7 5.90039V7.09961C7 7.32052 7.17948 7.5 7.40039 7.5H8.59961C8.82052 7.5 9 7.32052 9 7.09961V5.90039C9 5.67948 8.82052 5.5 8.59961 5.5H7.40039ZM10.4004 5.5C10.1795 5.5 10 5.67948 10 5.90039V7.09961C10 7.32052 10.1795 7.5 10.4004 7.5H11.5996C11.8205 7.5 12 7.32052 12 7.09961V5.90039C12 5.67948 11.8205 5.5 11.5996 5.5H10.4004Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingCalendar);
export default __webpack_public_path__ + "static/media/Upcoming_calendar.a054dc9c0e84fbb2eb73bd19f5958f2a.svg";
export { ForwardRef as ReactComponent };